import dayjs from 'dayjs';

export class MockedVitovalorPT2Features {
  mock(installationId: number, gatewaySerial: string) {
    return [
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.sensors',
        timestamp: '2020-02-26T04:20:58.402Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.sensors',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {
          activate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.operating.programs.forcedLastFromSchedule/activate',
            name: 'activate',
            isExecutable: true,
            params: {},
          },
          deactivate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.operating.programs.forcedLastFromSchedule/deactivate',
            name: 'deactivate',
            isExecutable: false,
            params: {},
          },
        },
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.programs.forcedLastFromSchedule',
        timestamp: '2020-02-26T04:21:34.372Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.programs.forcedLastFromSchedule',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'fuelCell.sensors',
        timestamp: '2020-02-26T04:20:58.403Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/fuelCell.sensors',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          start: {
            value: '2019-05-09',
            type: 'string',
          },
          end: {
            value: '2019-05-09',
            type: 'string',
          },
        },
        commands: {
          changeEndDate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.operating.programs.holidayAtHome/changeEndDate',
            name: 'changeEndDate',
            isExecutable: false,
            params: {
              end: {
                type: 'string',
                required: true,
                constraints: {
                  regEx: '^[\\d]{4}-[\\d]{2}-[\\d]{2}$',
                },
              },
            },
          },
          schedule: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.operating.programs.holidayAtHome/schedule',
            name: 'schedule',
            isExecutable: true,
            params: {
              start: {
                type: 'string',
                required: true,
                constraints: {
                  regEx: '^[\\d]{4}-[\\d]{2}-[\\d]{2}$',
                },
              },
              end: {
                type: 'string',
                required: true,
                constraints: {
                  regEx: '^[\\d]{4}-[\\d]{2}-[\\d]{2}$',
                },
              },
            },
          },
          unschedule: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.operating.programs.holidayAtHome/unschedule',
            name: 'unschedule',
            isExecutable: true,
            params: {},
          },
        },
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.programs.holidayAtHome',
        timestamp: '2020-02-26T04:21:33.976Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.programs.holidayAtHome',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'fuelCell.operating.modes.standby',
        timestamp: '2020-02-26T04:21:34.274Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/fuelCell.operating.modes.standby',
      },
      {
        properties: {
          value: {
            value: 47.3,
            unit: 'celsius',
            type: 'number',
          },
          status: {
            value: 'connected',
            type: 'string',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.sensors.temperature.supply',
        timestamp: '2020-02-26T07:11:34.285Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.sensors.temperature.supply',
      },
      {
        properties: {
          entries: {
            type: 'ErrorListChanges',
            constraints: {},
            value: {
              new: [],
              current: [],
              gone: [],
            },
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.errors.active',
        timestamp: '2020-01-09T04:04:32.921Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.errors.active',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.configuration.multiFamilyHouse',
        timestamp: '2020-02-26T04:20:58.496Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.configuration.multiFamilyHouse',
      },
      {
        properties: {
          active: {
            value: true,
            type: 'boolean',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.operating.modes.dhwAndHeating',
        timestamp: '2020-02-26T04:21:34.275Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.operating.modes.dhwAndHeating',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'fuelCell',
        timestamp: '2020-02-26T04:20:58.402Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/fuelCell',
      },
      {
        properties: {
          value: {
            value: 'dhwAndHeating',
            type: 'string',
          },
        },
        commands: {
          setMode: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.1.operating.modes.active/setMode',
            name: 'setMode',
            isExecutable: true,
            params: {
              mode: {
                type: 'string',
                required: true,
                constraints: {
                  enum: ['standby', 'heating', 'dhw', 'dhwAndHeating'],
                },
              },
            },
          },
        },
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.operating.modes.active',
        timestamp: '2020-02-26T04:21:34.273Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.operating.modes.active',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'fuelCell.sensors.temperature',
        timestamp: '2020-02-26T04:20:58.403Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/fuelCell.sensors.temperature',
      },
      {
        properties: {
          day: {
            value: [5.3, 15.8, 17.4, 15.9, 17.3, 15.9, 17.4, 15.9],
            type: 'array',
          },
          week: {
            value: [38.5, 115.80000000000001, 117.8, 117.2, 84.2, 118.69999999999999, 117.4, 115.1],
            type: 'array',
          },
          month: {
            value: [407.7, 522.4, 0, 497.2, 517.5, 458.5, 116.3, 204.1, 0, 432.8, 246.2, 0, 0],
            type: 'array',
          },
          year: {
            value: [930.1, 2472.9],
            type: 'array',
          },
          unit: {
            value: 'kilowattHour',
            type: 'string',
          },
          dayValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
          weekValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
          monthValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
          yearValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'fuelCell.power.production',
        timestamp: '2020-02-26T06:21:28.291Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/fuelCell.power.production',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.programs',
        timestamp: '2020-02-26T04:20:58.402Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.programs',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.sensors.power',
        timestamp: '2020-02-26T04:20:58.402Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.sensors.power',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'fuelCell.power',
        timestamp: '2020-02-26T04:20:58.402Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/fuelCell.power',
      },
      {
        properties: {
          active: {
            value: true,
            type: 'boolean',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'fuelCell.operating.modes.heatControlled',
        timestamp: '2020-02-26T04:21:34.274Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/fuelCell.operating.modes.heatControlled',
      },
      {
        properties: {
          day: {
            value: [5.3, 15.8, 17.4, 15.9, 17.3, 15.9, 17.4, 15.9],
            type: 'array',
          },
          week: {
            value: [38.5, 115.80000000000001, 117.8, 117.2, 84.2, 118.69999999999999, 117.4, 115.1],
            type: 'array',
          },
          month: {
            value: [407.7, 522.4, 0, 497.2, 517.5, 458.5, 116.3, 204.1, 0, 432.8, 246.2, 0, 0],
            type: 'array',
          },
          year: {
            value: [930.1, 2472.9],
            type: 'array',
          },
          unit: {
            value: 'kilowattHour',
            type: 'string',
          },
          dayValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
          weekValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
          monthValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
          yearValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.power.production',
        timestamp: '2020-02-26T06:21:28.336Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.power.production',
      },
      {
        properties: {
          value: {
            value: 52,
            unit: 'celsius',
            type: 'number',
          },
        },
        commands: {
          setTargetTemperature: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.dhw.temperature/setTargetTemperature',
            name: 'setTargetTemperature',
            isExecutable: true,
            params: {
              temperature: {
                type: 'number',
                required: true,
                constraints: {
                  min: 10,
                  max: 60,
                  stepping: 1,
                },
              },
            },
          },
        },
        gatewayId: gatewaySerial,
        feature: 'heating.dhw.temperature',
        timestamp: '2020-02-26T04:21:34.065Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.dhw.temperature',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'fuelCell.operating.modes',
        timestamp: '2020-02-26T04:20:58.402Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/fuelCell.operating.modes',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.power.purchase',
        timestamp: '2020-02-26T04:20:58.403Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.power.purchase',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          temperature: {
            value: 22,
            unit: 'celsius',
            type: 'number',
          },
        },
        commands: {
          setTemperature: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.operating.programs.comfort/setTemperature',
            name: 'setTemperature',
            isExecutable: true,
            params: {
              targetTemperature: {
                type: 'number',
                required: true,
                constraints: {
                  min: 3,
                  max: 37,
                  stepping: 1,
                },
              },
            },
          },
          activate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.operating.programs.comfort/activate',
            name: 'activate',
            isExecutable: false,
            params: {
              temperature: {
                type: 'number',
                required: false,
                constraints: {
                  min: 3,
                  max: 37,
                  stepping: 1,
                },
              },
            },
          },
          deactivate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.operating.programs.comfort/deactivate',
            name: 'deactivate',
            isExecutable: false,
            params: {},
          },
        },
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.programs.comfort',
        timestamp: '2020-02-26T04:21:34.275Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.programs.comfort',
      },
      {
        properties: {
          entries: {
            type: 'ErrorListChanges',
            constraints: {},
            value: {
              new: [],
              current: [
                {
                  errorCode: 'F.296',
                  timestamp: '2020-01-08T08:23:25.000Z',
                  accessLevel: 'customer',
                  priority: 'criticalError',
                },
                {
                  errorCode: 'F.160',
                  timestamp: '2020-01-08T08:23:25.000Z',
                  accessLevel: 'customer',
                  priority: 'criticalError',
                },
                {
                  errorCode: 'F.296',
                  timestamp: '2020-01-08T07:53:52.000Z',
                  accessLevel: 'customer',
                  priority: 'criticalError',
                },
                {
                  errorCode: 'F.341',
                  timestamp: '2020-01-08T07:45:23.000Z',
                  accessLevel: 'customer',
                  priority: 'criticalError',
                },
                {
                  errorCode: 'F.160',
                  timestamp: '2020-01-08T07:44:15.000Z',
                  accessLevel: 'customer',
                  priority: 'criticalError',
                },
                {
                  errorCode: 'F.160',
                  timestamp: '2019-12-19T01:32:50.000Z',
                  accessLevel: 'customer',
                  priority: 'criticalError',
                },
                {
                  errorCode: 'F.160',
                  timestamp: '2019-10-01T10:05:07.000Z',
                  accessLevel: 'customer',
                  priority: 'criticalError',
                },
                {
                  errorCode: 'F.160',
                  timestamp: '2019-10-01T10:04:30.000Z',
                  accessLevel: 'customer',
                  priority: 'criticalError',
                },
                {
                  errorCode: 'F.160',
                  timestamp: '2019-09-25T10:34:24.000Z',
                  accessLevel: 'customer',
                  priority: 'criticalError',
                },
                {
                  errorCode: 'F.160',
                  timestamp: '2019-09-04T02:51:18.000Z',
                  accessLevel: 'customer',
                  priority: 'criticalError',
                },
              ],
              gone: [],
            },
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.errors.history',
        timestamp: '2020-02-26T06:21:28.008Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.errors.history',
      },
      {
        properties: {
          value: {
            value: 30.3,
            type: 'number',
          },
          status: {
            value: 'connected',
            type: 'string',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.dhw.sensors.temperature.dhwCylinder.bottom',
        timestamp: '2020-02-26T07:11:38.197Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.dhw.sensors.temperature.dhwCylinder.bottom',
      },
      {
        properties: {
          value: {
            type: 'number',
            value: 24,
            unit: 'celsius',
          },
          status: {
            type: 'string',
            value: 'connected',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.dhw.sensors.temperature.dhwCylinder',
        gatewayId: gatewaySerial,
        feature: 'heating.dhw.sensors.temperature.dhwCylinder',
        timestamp: '2023-12-01T08:17:41.203Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            type: 'number',
            value: 23,
            unit: 'celsius',
          },
          status: {
            type: 'string',
            value: 'connected',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.dhw.sensors.temperature.dhwCylinder.top',
        gatewayId: gatewaySerial,
        feature: 'heating.dhw.sensors.temperature.dhwCylinder.top',
        timestamp: '2023-12-01T08:17:41.203Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            type: 'number',
            value: 22,
            unit: 'celsius',
          },
          status: {
            type: 'string',
            value: 'connected',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.dhw.sensors.temperature.dhwCylinder.middle',
        gatewayId: gatewaySerial,
        feature: 'heating.dhw.sensors.temperature.dhwCylinder.middle',
        timestamp: '2023-12-01T08:17:41.203Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            type: 'number',
            value: 24,
            unit: 'celsius',
          },
          status: {
            type: 'string',
            value: 'connected',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.dhw.sensors.temperature.dhwCylinder.midBottom',
        gatewayId: gatewaySerial,
        feature: 'heating.dhw.sensors.temperature.dhwCylinder.midBottom',
        timestamp: '2023-12-01T08:17:41.203Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            type: 'number',
            value: 23,
            unit: 'celsius',
          },
          status: {
            type: 'string',
            value: 'connected',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.dhw.sensors.temperature.dhwCylinder.bottom',
        gatewayId: gatewaySerial,
        feature: 'heating.dhw.sensors.temperature.dhwCylinder.bottom',
        timestamp: '2023-12-01T08:17:41.203Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            unit: 'kilowattHour',
            value: 4140,
            type: 'number',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.power.production.cumulative',
        timestamp: '2020-02-26T06:15:48.372Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.power.production.cumulative',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.boiler',
        timestamp: '2020-02-26T04:20:58.402Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.boiler',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          temperature: {
            value: 22,
            unit: 'celsius',
            type: 'number',
          },
        },
        commands: {
          setTemperature: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.1.operating.programs.comfort/setTemperature',
            name: 'setTemperature',
            isExecutable: true,
            params: {
              targetTemperature: {
                type: 'number',
                required: true,
                constraints: {
                  min: 3,
                  max: 37,
                  stepping: 1,
                },
              },
            },
          },
          activate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.1.operating.programs.comfort/activate',
            name: 'activate',
            isExecutable: false,
            params: {
              temperature: {
                type: 'number',
                required: false,
                constraints: {
                  min: 3,
                  max: 37,
                  stepping: 1,
                },
              },
            },
          },
          deactivate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.1.operating.programs.comfort/deactivate',
            name: 'deactivate',
            isExecutable: false,
            params: {},
          },
        },
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.operating.programs.comfort',
        timestamp: '2020-02-26T04:21:34.276Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.operating.programs.comfort',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.sensors.temperature',
        timestamp: '2020-02-26T04:20:58.403Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.sensors.temperature',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.programs.standby',
        timestamp: '2020-02-26T04:21:34.273Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.programs.standby',
      },
      {
        properties: {
          day: {
            value: [1.5, 4.5, 5, 4.5, 5, 4.5, 5, 4.5],
            type: 'array',
            unit: 'cubicMeter',
          },
          week: {
            value: [11, 33, 33.5, 33, 24, 33, 33.099999999999994, 32.3],
            type: 'array',
            unit: 'cubicMeter',
          },
          month: {
            value: [116.7, 147.5, 0, 141.2, 148.1, 125.5, 33.9, 58.4, 0, 110.7, 65.6, 0, 0],
            type: 'array',
            unit: 'cubicMeter',
          },
          year: {
            value: [264.3, 683.7],
            type: 'array',
            unit: 'cubicMeter',
          },
          dayValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
          weekValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
          monthValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
          yearValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.gas.consumption.fuelCell',
        timestamp: '2020-02-26T06:21:27.854Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.gas.consumption.fuelCell',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.modes.heating',
        timestamp: '2020-02-26T04:21:34.065Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.modes.heating',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.operating.programs',
        timestamp: '2020-02-26T04:20:58.402Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.operating.programs',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.boiler.sensors',
        timestamp: '2020-02-26T04:20:58.403Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.boiler.sensors',
      },
      {
        properties: {
          value: {
            unit: 'kilowattHour',
            value: 2644.7,
            type: 'number',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.power.sold.cumulative',
        timestamp: '2020-02-26T07:06:44.752Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.power.sold.cumulative',
      },
      {
        properties: {
          day: {
            value: [3.9, 14, 14.8, 13.6, 13.799999999999999, 13.1, 11.8, 11.4],
            type: 'array',
          },
          week: {
            value: [
              32.7,
              87.69999999999999,
              95.39999999999999,
              88.60000000000001,
              79.10000000000001,
              95.4,
              85.39999999999999,
              85.4,
            ],
            type: 'array',
          },
          month: {
            value: [
              323.1,
              408.9,
              278,
              378.7,
              232.7,
              153.7,
              62.5,
              88.8,
              29,
              225.39999999999998,
              165.6,
              0,
              0,
            ],
            type: 'array',
          },
          year: {
            value: [732.3, 1615.3],
            type: 'array',
          },
          unit: {
            value: 'cubicMeter',
            type: 'string',
          },
          dayValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
          weekValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
          monthValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
          yearValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.gas.consumption.total',
        timestamp: '2020-02-26T06:21:27.997Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.gas.consumption.total',
      },
      {
        properties: {
          status: {
            value: 'off',
            type: 'string',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.frostprotection',
        timestamp: '2020-02-26T04:21:34.272Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.frostprotection',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.power.production.demandCoverage',
        timestamp: '2020-02-26T04:20:58.402Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.power.production.demandCoverage',
      },
      {
        properties: {
          value: {
            value: 'heatControlled',
            type: 'string',
          },
        },
        commands: {
          setMode: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/fuelCell.operating.modes.active/setMode',
            name: 'setMode',
            isExecutable: false,
            params: {
              mode: {
                type: 'string',
                required: true,
                constraints: {
                  enum: ['standby', 'maintenance', 'heatControlled', 'economical', 'ecological'],
                },
              },
            },
          },
        },
        gatewayId: gatewaySerial,
        feature: 'fuelCell.operating.modes.active',
        timestamp: '2020-02-26T04:21:34.274Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/fuelCell.operating.modes.active',
      },
      {
        properties: {
          value: {
            value: '7725048-device-serial',
            type: 'string',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.boiler.serial',
        timestamp: '2020-02-26T04:21:31.589Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.boiler.serial',
      },
      {
        properties: {
          day: {
            value: [22, 90, 99, 90, 96, 84, 96, 90],
            type: 'array',
          },
          week: {
            value: [211, 639, 651, 644, 646, 646, 647, 623],
            type: 'array',
          },
          month: {
            value: [77, 94, 93, 89, 94, 82, 27, 36, 30, 75, 42, 0, 0],
            type: 'array',
          },
          year: {
            value: [13, 52],
            type: 'array',
          },
          unit: {
            value: 'percent',
            type: 'string',
          },
          dayValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
          weekValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
          monthValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
          yearValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.power.production.demandCoverage.raw',
        timestamp: '2020-02-26T04:21:34.272Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.power.production.demandCoverage.raw',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.operating',
        timestamp: '2020-02-26T04:20:58.402Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.operating',
      },
      {
        properties: {
          value: {
            value: 43.6,
            type: 'number',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.temperature',
        timestamp: '2020-02-26T07:12:59.900Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.temperature',
      },
      {
        properties: {
          status: {
            value: 'on',
            type: 'string',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.dhw.pumps.circulation',
        timestamp: '2020-02-26T05:29:42.702Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.dhw.pumps.circulation',
      },
      {
        properties: {
          value: {
            value: 36.8,
            type: 'number',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.temperature',
        timestamp: '2020-02-26T07:12:59.997Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.temperature',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {
          activate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.1.operating.programs.forcedLastFromSchedule/activate',
            name: 'activate',
            isExecutable: true,
            params: {},
          },
          deactivate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.1.operating.programs.forcedLastFromSchedule/deactivate',
            name: 'deactivate',
            isExecutable: false,
            params: {},
          },
        },
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.operating.programs.forcedLastFromSchedule',
        timestamp: '2020-02-26T04:21:34.367Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.operating.programs.forcedLastFromSchedule',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.heat',
        timestamp: '2020-02-26T04:20:58.402Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.heat',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.sensors.temperature',
        timestamp: '2020-02-26T04:20:58.403Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.sensors.temperature',
      },
      {
        properties: {
          value: {
            value: 4140,
            type: 'number',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.power.production.cumulative',
        timestamp: '2020-02-26T06:15:48.363Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.power.production.cumulative',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.power',
        timestamp: '2020-02-26T04:20:58.402Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.power',
      },
      {
        properties: {
          value: {
            value: 'generation',
            type: 'string',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'fuelCell.operating.phase',
        timestamp: '2020-02-26T04:21:34.144Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/fuelCell.operating.phase',
      },
      {
        properties: {
          value: {
            value: '7725048-device-serial',
            type: 'string',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'device.serial',
        timestamp: '2020-02-26T04:21:31.590Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/device.serial',
      },
      {
        properties: {
          active: {
            value: true,
            type: 'boolean',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.burners.0',
        timestamp: '2020-02-26T07:05:44.178Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.burners.0',
      },
      {
        properties: {
          value: {
            value: 48.3,
            unit: 'celsius',
            type: 'number',
          },
          status: {
            value: 'connected',
            type: 'string',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.sensors.temperature.hydraulicSeparator',
        timestamp: '2020-02-26T07:13:10.199Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.sensors.temperature.hydraulicSeparator',
      },
      {
        properties: {
          value: {
            value: 'normal',
            type: 'string',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.programs.active',
        timestamp: '2020-02-26T06:19:40.178Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.programs.active',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          start: {
            value: '2019-10-15',
            type: 'string',
          },
          end: {
            value: '2019-10-15',
            type: 'string',
          },
        },
        commands: {
          changeEndDate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.1.operating.programs.holiday/changeEndDate',
            name: 'changeEndDate',
            isExecutable: false,
            params: {
              end: {
                type: 'string',
                required: true,
                constraints: {
                  regEx: '^[\\d]{4}-[\\d]{2}-[\\d]{2}$',
                },
              },
            },
          },
          schedule: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.1.operating.programs.holiday/schedule',
            name: 'schedule',
            isExecutable: true,
            params: {
              start: {
                type: 'string',
                required: true,
                constraints: {
                  regEx: '^[\\d]{4}-[\\d]{2}-[\\d]{2}$',
                },
              },
              end: {
                type: 'string',
                required: true,
                constraints: {
                  regEx: '^[\\d]{4}-[\\d]{2}-[\\d]{2}$',
                },
              },
            },
          },
          unschedule: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.1.operating.programs.holiday/unschedule',
            name: 'unschedule',
            isExecutable: true,
            params: {},
          },
        },
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.operating.programs.holiday',
        timestamp: '2020-02-26T04:21:33.976Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.operating.programs.holiday',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.sensors',
        timestamp: '2020-02-26T04:20:58.403Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.sensors',
      },
      {
        properties: {
          value: {
            value: 78,
            type: 'number',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.boiler.temperature',
        timestamp: '2020-02-26T04:21:32.856Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.boiler.temperature',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.2.operating.modes',
        timestamp: '2020-02-26T04:20:58.403Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.2.operating.modes',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.2.sensors.temperature',
        timestamp: '2020-02-26T04:20:58.403Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.2.sensors.temperature',
      },
      {
        properties: {
          value: {
            value: 5,
            type: 'number',
          },
          unit: {
            value: 'percent',
            type: 'string',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.power.production.productionCoverage.current',
        timestamp: '2020-02-26T04:21:34.227Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.power.production.productionCoverage.current',
      },
      {
        properties: {
          active: {
            value: true,
            type: 'boolean',
          },
          entries: {
            value: {
              mon: [
                {
                  mode: 'normal',
                  start: '07:20',
                  end: '22:30',
                  position: 0,
                },
              ],
              tue: [
                {
                  mode: 'normal',
                  start: '07:20',
                  end: '22:30',
                  position: 0,
                },
              ],
              wed: [
                {
                  mode: 'normal',
                  start: '07:20',
                  end: '22:30',
                  position: 0,
                },
              ],
              thu: [
                {
                  mode: 'normal',
                  start: '07:20',
                  end: '22:30',
                  position: 0,
                },
              ],
              fri: [
                {
                  mode: 'normal',
                  start: '07:20',
                  end: '22:30',
                  position: 0,
                },
              ],
              sat: [
                {
                  mode: 'normal',
                  start: '07:20',
                  end: '22:30',
                  position: 0,
                },
              ],
              sun: [
                {
                  mode: 'normal',
                  start: '07:20',
                  end: '22:30',
                  position: 0,
                },
              ],
            },
            type: 'Schedule',
          },
        },
        commands: {
          setSchedule: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.heating.schedule/setSchedule',
            name: 'setSchedule',
            isExecutable: true,
            params: {
              newSchedule: {
                type: 'Schedule',
                required: true,
                constraints: {
                  modes: ['normal', 'comfort'],
                  maxEntries: 4,
                  resolution: 10,
                  defaultMode: 'reduced',
                  overlapAllowed: false,
                },
              },
            },
          },
        },
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.heating.schedule',
        timestamp: '2020-02-26T04:21:34.276Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.heating.schedule',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.errors',
        timestamp: '2020-02-26T04:20:58.402Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.errors',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.modes.standby',
        timestamp: '2020-02-26T04:21:34.064Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.modes.standby',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.2.heating',
        timestamp: '2020-02-26T04:20:58.403Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.2.heating',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.heating',
        timestamp: '2020-02-26T04:20:58.402Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.heating',
      },
      {
        properties: {
          value: {
            unit: 'kilowattHour',
            value: 1052.7,
            type: 'number',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.power.purchase.cumulative',
        timestamp: '2020-02-26T04:21:32.893Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.power.purchase.cumulative',
      },
      {
        properties: {
          status: {
            value: 'connected',
            type: 'string',
          },
          value: {
            value: 720,
            type: 'number',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.power.production.current',
        timestamp: '2020-02-26T07:12:58.867Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.power.production.current',
      },
      {
        properties: {
          value: {
            value: 45.3,
            type: 'number',
            unit: 'celsius',
          },
          status: {
            value: 'connected',
            type: 'string',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.dhw.sensors.temperature.hotWaterStorage',
        timestamp: '2020-02-26T07:11:38.314Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.dhw.sensors.temperature.hotWaterStorage',
      },
      {
        properties: {
          value: {
            value: 50.2,
            unit: 'celsius',
            type: 'number',
          },
          status: {
            value: 'connected',
            type: 'string',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.boiler.sensors.temperature.commonSupply',
        timestamp: '2020-02-26T07:13:13.131Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.boiler.sensors.temperature.commonSupply',
      },
      {
        properties: {
          active: {
            value: true,
            type: 'boolean',
          },
          entries: {
            value: {
              mon: [
                {
                  mode: 'on',
                  start: '06:30',
                  end: '23:30',
                  position: 0,
                },
              ],
              tue: [
                {
                  mode: 'on',
                  start: '06:30',
                  end: '23:30',
                  position: 0,
                },
              ],
              wed: [
                {
                  mode: 'on',
                  start: '06:30',
                  end: '23:30',
                  position: 0,
                },
              ],
              thu: [
                {
                  mode: 'on',
                  start: '06:30',
                  end: '23:30',
                  position: 0,
                },
              ],
              fri: [
                {
                  mode: 'on',
                  start: '06:30',
                  end: '23:30',
                  position: 0,
                },
              ],
              sat: [
                {
                  mode: 'on',
                  start: '06:30',
                  end: '23:30',
                  position: 0,
                },
              ],
              sun: [
                {
                  mode: 'on',
                  start: '06:30',
                  end: '23:30',
                  position: 0,
                },
              ],
            },
            type: 'Schedule',
          },
        },
        commands: {
          setSchedule: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.dhw.schedule/setSchedule',
            name: 'setSchedule',
            isExecutable: true,
            params: {
              newSchedule: {
                type: 'Schedule',
                required: true,
                constraints: {
                  modes: ['on'],
                  maxEntries: 4,
                  resolution: 10,
                  defaultMode: 'off',
                  overlapAllowed: false,
                },
              },
            },
          },
        },
        gatewayId: gatewaySerial,
        feature: 'heating.dhw.schedule',
        timestamp: '2020-02-26T04:21:33.980Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.dhw.schedule',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.device.time',
        timestamp: '2020-02-26T04:20:58.403Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.device.time',
      },
      {
        properties: {
          active: {
            value: true,
            type: 'boolean',
          },
          entries: {
            value: {
              mon: [
                {
                  mode: 'on',
                  start: '06:30',
                  end: '13:30',
                  position: 0,
                },
                {
                  mode: 'on',
                  start: '14:00',
                  end: '16:30',
                  position: 1,
                },
                {
                  mode: 'on',
                  start: '17:00',
                  end: '20:40',
                  position: 2,
                },
                {
                  mode: 'on',
                  start: '21:40',
                  end: '24:00',
                  position: 3,
                },
              ],
              tue: [
                {
                  mode: 'on',
                  start: '06:30',
                  end: '13:30',
                  position: 0,
                },
                {
                  mode: 'on',
                  start: '14:00',
                  end: '16:30',
                  position: 1,
                },
                {
                  mode: 'on',
                  start: '17:00',
                  end: '20:40',
                  position: 2,
                },
                {
                  mode: 'on',
                  start: '21:40',
                  end: '24:00',
                  position: 3,
                },
              ],
              wed: [
                {
                  mode: 'on',
                  start: '06:30',
                  end: '13:30',
                  position: 0,
                },
                {
                  mode: 'on',
                  start: '14:00',
                  end: '16:30',
                  position: 1,
                },
                {
                  mode: 'on',
                  start: '17:00',
                  end: '20:40',
                  position: 2,
                },
                {
                  mode: 'on',
                  start: '21:40',
                  end: '24:00',
                  position: 3,
                },
              ],
              thu: [
                {
                  mode: 'on',
                  start: '06:30',
                  end: '13:30',
                  position: 0,
                },
                {
                  mode: 'on',
                  start: '14:00',
                  end: '16:30',
                  position: 1,
                },
                {
                  mode: 'on',
                  start: '17:00',
                  end: '20:40',
                  position: 2,
                },
                {
                  mode: 'on',
                  start: '21:40',
                  end: '24:00',
                  position: 3,
                },
              ],
              fri: [
                {
                  mode: 'on',
                  start: '06:30',
                  end: '13:30',
                  position: 0,
                },
                {
                  mode: 'on',
                  start: '14:00',
                  end: '16:30',
                  position: 1,
                },
                {
                  mode: 'on',
                  start: '17:00',
                  end: '20:40',
                  position: 2,
                },
                {
                  mode: 'on',
                  start: '21:40',
                  end: '24:00',
                  position: 3,
                },
              ],
              sat: [
                {
                  mode: 'on',
                  start: '06:30',
                  end: '13:30',
                  position: 0,
                },
                {
                  mode: 'on',
                  start: '14:00',
                  end: '16:30',
                  position: 1,
                },
                {
                  mode: 'on',
                  start: '17:00',
                  end: '20:40',
                  position: 2,
                },
                {
                  mode: 'on',
                  start: '21:40',
                  end: '24:00',
                  position: 3,
                },
              ],
              sun: [
                {
                  mode: 'on',
                  start: '06:30',
                  end: '13:30',
                  position: 0,
                },
                {
                  mode: 'on',
                  start: '14:00',
                  end: '16:30',
                  position: 1,
                },
                {
                  mode: 'on',
                  start: '17:00',
                  end: '20:40',
                  position: 2,
                },
                {
                  mode: 'on',
                  start: '21:40',
                  end: '24:00',
                  position: 3,
                },
              ],
            },
            type: 'Schedule',
          },
        },
        commands: {
          setSchedule: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.dhw.pumps.circulation.schedule/setSchedule',
            name: 'setSchedule',
            isExecutable: true,
            params: {
              newSchedule: {
                type: 'Schedule',
                required: true,
                constraints: {
                  modes: ['on'],
                  maxEntries: 4,
                  resolution: 10,
                  defaultMode: 'off',
                  overlapAllowed: false,
                },
              },
            },
          },
        },
        gatewayId: gatewaySerial,
        feature: 'heating.dhw.pumps.circulation.schedule',
        timestamp: '2020-02-26T04:21:34.044Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.dhw.pumps.circulation.schedule',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.circulation',
        timestamp: '2020-02-26T04:20:58.402Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.circulation',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          start: {
            value: '2019-10-15',
            type: 'string',
          },
          end: {
            value: '2019-10-15',
            type: 'string',
          },
        },
        commands: {
          changeEndDate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.operating.programs.holiday/changeEndDate',
            name: 'changeEndDate',
            isExecutable: false,
            params: {
              end: {
                type: 'string',
                required: true,
                constraints: {
                  regEx: '^[\\d]{4}-[\\d]{2}-[\\d]{2}$',
                },
              },
            },
          },
          schedule: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.operating.programs.holiday/schedule',
            name: 'schedule',
            isExecutable: true,
            params: {
              start: {
                type: 'string',
                required: true,
                constraints: {
                  regEx: '^[\\d]{4}-[\\d]{2}-[\\d]{2}$',
                },
              },
              end: {
                type: 'string',
                required: true,
                constraints: {
                  regEx: '^[\\d]{4}-[\\d]{2}-[\\d]{2}$',
                },
              },
            },
          },
          unschedule: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.operating.programs.holiday/unschedule',
            name: 'unschedule',
            isExecutable: true,
            params: {},
          },
        },
        gatewayId: gatewaySerial,
        feature: 'heating.operating.programs.holiday',
        timestamp: '2020-02-26T04:21:34.065Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.operating.programs.holiday',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.operating.modes.dhw',
        timestamp: '2020-02-26T04:21:34.274Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.operating.modes.dhw',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.2.operating',
        timestamp: '2020-02-26T04:20:58.402Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.2.operating',
      },
      {
        properties: {
          active: {
            value: true,
            type: 'boolean',
          },
          entries: {
            value: {
              mon: [
                {
                  mode: 'normal',
                  start: '07:00',
                  end: '22:40',
                  position: 0,
                },
              ],
              tue: [
                {
                  mode: 'normal',
                  start: '07:00',
                  end: '22:40',
                  position: 0,
                },
              ],
              wed: [
                {
                  mode: 'normal',
                  start: '07:00',
                  end: '22:40',
                  position: 0,
                },
              ],
              thu: [
                {
                  mode: 'normal',
                  start: '07:00',
                  end: '22:40',
                  position: 0,
                },
              ],
              fri: [
                {
                  mode: 'normal',
                  start: '07:00',
                  end: '22:40',
                  position: 0,
                },
              ],
              sat: [
                {
                  mode: 'normal',
                  start: '07:00',
                  end: '22:40',
                  position: 0,
                },
              ],
              sun: [
                {
                  mode: 'normal',
                  start: '07:00',
                  end: '22:40',
                  position: 0,
                },
              ],
            },
            type: 'Schedule',
          },
        },
        commands: {
          setSchedule: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.1.heating.schedule/setSchedule',
            name: 'setSchedule',
            isExecutable: true,
            params: {
              newSchedule: {
                type: 'Schedule',
                required: true,
                constraints: {
                  modes: ['normal', 'comfort'],
                  maxEntries: 4,
                  resolution: 10,
                  defaultMode: 'reduced',
                  overlapAllowed: false,
                },
              },
            },
          },
        },
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.heating.schedule',
        timestamp: '2020-02-26T04:21:34.276Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.heating.schedule',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'fuelCell.operating.modes.ecological',
        timestamp: '2020-02-26T04:21:34.276Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/fuelCell.operating.modes.ecological',
      },
      {
        properties: {
          value: {
            value: 68.1,
            type: 'number',
          },
          status: {
            value: 'connected',
            type: 'string',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'fuelCell.sensors.temperature.supply',
        timestamp: '2020-02-26T07:13:08.771Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/fuelCell.sensors.temperature.supply',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.sensors.temperature',
        timestamp: '2020-02-26T04:20:58.403Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.sensors.temperature',
      },
      {
        properties: {
          value: {
            value: 'normal',
            type: 'string',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.operating.programs.active',
        timestamp: '2020-02-26T05:59:39.369Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.operating.programs.active',
      },
      {
        properties: {
          value: {
            value: 1.6,
            unit: 'bar',
            type: 'number',
          },
          status: {
            value: 'connected',
            type: 'string',
          },
          unit: {
            value: 'bar',
            type: 'string',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.sensors.pressure.supply',
        timestamp: '2020-02-26T07:08:36.285Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.sensors.pressure.supply',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.operating.programs.standby',
        timestamp: '2020-02-26T04:21:34.276Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.operating.programs.standby',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          start: {
            value: '2019-05-09',
            type: 'string',
          },
          end: {
            value: '2019-05-09',
            type: 'string',
          },
        },
        commands: {
          changeEndDate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.operating.programs.holidayAtHome/changeEndDate',
            name: 'changeEndDate',
            isExecutable: false,
            params: {
              end: {
                type: 'string',
                required: true,
                constraints: {
                  regEx: '^[\\d]{4}-[\\d]{2}-[\\d]{2}$',
                },
              },
            },
          },
          schedule: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.operating.programs.holidayAtHome/schedule',
            name: 'schedule',
            isExecutable: true,
            params: {
              start: {
                type: 'string',
                required: true,
                constraints: {
                  regEx: '^[\\d]{4}-[\\d]{2}-[\\d]{2}$',
                },
              },
              end: {
                type: 'string',
                required: true,
                constraints: {
                  regEx: '^[\\d]{4}-[\\d]{2}-[\\d]{2}$',
                },
              },
            },
          },
          unschedule: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.operating.programs.holidayAtHome/unschedule',
            name: 'unschedule',
            isExecutable: true,
            params: {},
          },
        },
        gatewayId: gatewaySerial,
        feature: 'heating.operating.programs.holidayAtHome',
        timestamp: '2020-02-26T04:21:33.982Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.operating.programs.holidayAtHome',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.sensors.pressure',
        timestamp: '2020-02-26T04:20:58.402Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.sensors.pressure',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          start: {
            value: '2019-10-15',
            type: 'string',
          },
          end: {
            value: '2019-10-15',
            type: 'string',
          },
        },
        commands: {
          changeEndDate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.operating.programs.holiday/changeEndDate',
            name: 'changeEndDate',
            isExecutable: false,
            params: {
              end: {
                type: 'string',
                required: true,
                constraints: {
                  regEx: '^[\\d]{4}-[\\d]{2}-[\\d]{2}$',
                },
              },
            },
          },
          schedule: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.operating.programs.holiday/schedule',
            name: 'schedule',
            isExecutable: true,
            params: {
              start: {
                type: 'string',
                required: true,
                constraints: {
                  regEx: '^[\\d]{4}-[\\d]{2}-[\\d]{2}$',
                },
              },
              end: {
                type: 'string',
                required: true,
                constraints: {
                  regEx: '^[\\d]{4}-[\\d]{2}-[\\d]{2}$',
                },
              },
            },
          },
          unschedule: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.operating.programs.holiday/unschedule',
            name: 'unschedule',
            isExecutable: true,
            params: {},
          },
        },
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.programs.holiday',
        timestamp: '2020-02-26T04:21:33.976Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.programs.holiday',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.dhw.pumps',
        timestamp: '2020-02-26T04:20:58.402Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.dhw.pumps',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          temperature: {
            value: 18,
            type: 'number',
          },
        },
        commands: {
          setTemperature: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.1.operating.programs.reduced/setTemperature',
            name: 'setTemperature',
            isExecutable: true,
            params: {
              targetTemperature: {
                type: 'number',
                required: true,
                constraints: {
                  min: 3,
                  max: 37,
                  stepping: 1,
                },
              },
            },
          },
        },
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.operating.programs.reduced',
        timestamp: '2020-02-26T05:59:39.387Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.operating.programs.reduced',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'fuelCell.operating.modes.maintenance',
        timestamp: '2020-02-26T04:21:34.272Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/fuelCell.operating.modes.maintenance',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.3.sensors',
        timestamp: '2020-02-26T04:20:58.403Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.3.sensors',
      },
      {
        properties: {
          value: {
            value: 1.7,
            unit: 'celsius',
            type: 'number',
          },
          status: {
            value: 'connected',
            type: 'string',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.sensors.temperature.outside',
        timestamp: '2020-02-26T06:51:43.639Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.sensors.temperature.outside',
      },
      {
        properties: {
          day: {
            value: [0.1, 1.3, 1, 1.4, 1.2, 1.2, 1.4, 0.9],
            type: 'array',
            unit: 'cubicMeter',
          },
          week: {
            value: [2.4000000000000004, 8.4, 10.5, 8.8, 8.8, 9.6, 9.200000000000001, 8.9],
            type: 'array',
            unit: 'cubicMeter',
          },
          month: {
            value: [32.4, 39.8, 38.4, 32.5, 29, 21.4, 23, 14.3, 16.5, 11.6, 7.7, 0, 0],
            type: 'array',
            unit: 'cubicMeter',
          },
          year: {
            value: [72.3, 194.8],
            type: 'array',
            unit: 'cubicMeter',
          },
          dayValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
          weekValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
          monthValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
          yearValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.gas.consumption.dhw',
        timestamp: '2020-02-26T06:21:27.997Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.gas.consumption.dhw',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {
          activate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.dhw.oneTimeCharge/activate',
            name: 'activate',
            isExecutable: true,
            params: {},
          },
          deactivate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.dhw.oneTimeCharge/deactivate',
            name: 'deactivate',
            isExecutable: false,
            params: {},
          },
        },
        gatewayId: gatewaySerial,
        feature: 'heating.dhw.oneTimeCharge',
        timestamp: '2020-02-26T04:21:34.065Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.dhw.oneTimeCharge',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          start: {
            value: '2019-05-09',
            type: 'string',
          },
          end: {
            value: '2019-05-09',
            type: 'string',
          },
        },
        commands: {
          changeEndDate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.1.operating.programs.holidayAtHome/changeEndDate',
            name: 'changeEndDate',
            isExecutable: false,
            params: {
              end: {
                type: 'string',
                required: true,
                constraints: {
                  regEx: '^[\\d]{4}-[\\d]{2}-[\\d]{2}$',
                },
              },
            },
          },
          schedule: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.1.operating.programs.holidayAtHome/schedule',
            name: 'schedule',
            isExecutable: true,
            params: {
              start: {
                type: 'string',
                required: true,
                constraints: {
                  regEx: '^[\\d]{4}-[\\d]{2}-[\\d]{2}$',
                },
              },
              end: {
                type: 'string',
                required: true,
                constraints: {
                  regEx: '^[\\d]{4}-[\\d]{2}-[\\d]{2}$',
                },
              },
            },
          },
          unschedule: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.1.operating.programs.holidayAtHome/unschedule',
            name: 'unschedule',
            isExecutable: true,
            params: {},
          },
        },
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.operating.programs.holidayAtHome',
        timestamp: '2020-02-26T04:21:33.977Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.operating.programs.holidayAtHome',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating',
        timestamp: '2020-02-26T04:20:58.402Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.sensors',
        timestamp: '2020-02-26T04:20:58.403Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.sensors',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'device',
        timestamp: '2020-02-26T04:20:58.403Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/device',
      },
      {
        properties: {
          enabled: {
            value: ['0', '1'],
            type: 'array',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits',
        timestamp: '2020-02-26T04:21:34.039Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits',
      },
      {
        properties: {
          value: {
            value: 52,
            unit: 'celsius',
            type: 'number',
          },
        },
        commands: {
          setTargetTemperature: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.dhw.temperature.main/setTargetTemperature',
            name: 'setTargetTemperature',
            isExecutable: true,
            params: {
              temperature: {
                type: 'number',
                required: true,
                constraints: {
                  min: 10,
                  max: 60,
                  stepping: 1,
                },
              },
            },
          },
        },
        gatewayId: gatewaySerial,
        feature: 'heating.dhw.temperature.main',
        timestamp: '2020-02-26T04:21:34.103Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.dhw.temperature.main',
      },
      {
        properties: {
          day: {
            value: [23, 82.1, 88.1, 77.1, 76.1, 74.1, 54, 60.1],
            type: 'array',
          },
          week: {
            value: [193.2, 463.6, 514.5, 468.4, 463.4, 528.7, 431.4, 442.29999999999995],
            type: 'array',
          },
          month: {
            value: [1740.7, 2216.7, 2396.7, 2050.3, 556.9, 68, 56, 161.2, 125.1, 1031.2, 923, 0, 0],
            type: 'array',
          },
          year: {
            value: [3957.4, 7368.8],
            type: 'array',
          },
          unit: {
            value: 'kilowattHour',
            type: 'string',
          },
          dayValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
          weekValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
          monthValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
          yearValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.heat.production',
        timestamp: '2020-02-26T06:21:28.249Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.heat.production',
      },
      {
        properties: {
          status: {
            value: 'notConnected',
            type: 'string',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.sensors.temperature.room',
        timestamp: '2020-02-26T04:21:33.980Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.sensors.temperature.room',
      },
      {
        properties: {
          value: {
            value: 720,
            type: 'number',
          },
          status: {
            value: 'connected',
            type: 'string',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.power.production.current',
        timestamp: '2020-02-26T07:12:58.855Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.power.production.current',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.modes.dhw',
        timestamp: '2020-02-26T04:21:34.402Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.modes.dhw',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'fuelCell.operating.modes.economical',
        timestamp: '2020-02-26T04:21:34.275Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/fuelCell.operating.modes.economical',
      },
      {
        properties: {
          min: {
            value: 10,
            type: 'number',
          },
          max: {
            value: 10,
            type: 'number',
          },
          default: {
            value: 50,
            type: 'number',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.dhw.temperature.levels',
        timestamp: '2020-02-26T04:21:31.722Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.dhw.temperature.levels',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.co2',
        timestamp: '2020-02-26T04:20:58.402Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.co2',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.3.operating.programs',
        timestamp: '2020-02-26T04:20:58.402Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.3.operating.programs',
      },
      {
        properties: {
          active: {
            value: true,
            type: 'boolean',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.modes.dhwAndHeating',
        timestamp: '2020-02-26T04:21:34.275Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.modes.dhwAndHeating',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.operating.programs',
        timestamp: '2020-02-26T04:20:58.402Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.operating.programs',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.operating.modes.standby',
        timestamp: '2020-02-26T04:21:33.977Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.operating.modes.standby',
      },
      {
        properties: {
          status: {
            value: 'connected',
            type: 'string',
          },
          value: {
            value: 595,
            unit: 'liter',
            type: 'number',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.sensors.volumetricFlow.allengra',
        timestamp: '2020-02-26T07:12:38.563Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.sensors.volumetricFlow.allengra',
      },
      {
        properties: {
          value: {
            value: 0,
            type: 'number',
          },
          unit: {
            value: 'watt',
            type: 'string',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.power.purchase.current',
        timestamp: '2020-02-26T06:28:48.174Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.power.purchase.current',
      },
      {
        properties: {
          active: {
            value: true,
            type: 'boolean',
          },
          name: {
            value: 'HEIZKÖRPER',
            type: 'string',
          },
          type: {
            value: 'heatingCircuit',
          },
        },
        commands: {
          setName: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0/setName',
            name: 'setName',
            isExecutable: true,
            params: {
              name: {
                type: 'string',
                required: true,
                constraints: {
                  minLength: 1,
                  maxLength: 20,
                },
              },
            },
          },
        },
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0',
        timestamp: '2020-02-26T04:21:33.973Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0',
      },
      {
        properties: {
          status: {
            value: 'off',
            type: 'string',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.frostprotection',
        timestamp: '2020-02-26T04:21:34.272Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.frostprotection',
      },
      {
        properties: {
          value: {
            value: 35.2,
            type: 'number',
          },
          status: {
            value: 'connected',
            type: 'string',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'fuelCell.sensors.temperature.return',
        timestamp: '2020-02-26T07:13:11.101Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/fuelCell.sensors.temperature.return',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.power.production.productionCoverage',
        timestamp: '2020-02-26T04:20:58.402Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.power.production.productionCoverage',
      },
      {
        properties: {
          active: {
            value: true,
            type: 'boolean',
          },
          entries: {
            value: {
              mon: [
                {
                  mode: 'on',
                  start: '06:30',
                  end: '13:30',
                  position: 0,
                },
                {
                  mode: 'on',
                  start: '14:00',
                  end: '16:30',
                  position: 1,
                },
                {
                  mode: 'on',
                  start: '17:00',
                  end: '20:40',
                  position: 2,
                },
                {
                  mode: 'on',
                  start: '21:40',
                  end: '24:00',
                  position: 3,
                },
              ],
              tue: [
                {
                  mode: 'on',
                  start: '06:30',
                  end: '13:30',
                  position: 0,
                },
                {
                  mode: 'on',
                  start: '14:00',
                  end: '16:30',
                  position: 1,
                },
                {
                  mode: 'on',
                  start: '17:00',
                  end: '20:40',
                  position: 2,
                },
                {
                  mode: 'on',
                  start: '21:40',
                  end: '24:00',
                  position: 3,
                },
              ],
              wed: [
                {
                  mode: 'on',
                  start: '06:30',
                  end: '13:30',
                  position: 0,
                },
                {
                  mode: 'on',
                  start: '14:00',
                  end: '16:30',
                  position: 1,
                },
                {
                  mode: 'on',
                  start: '17:00',
                  end: '20:40',
                  position: 2,
                },
                {
                  mode: 'on',
                  start: '21:40',
                  end: '24:00',
                  position: 3,
                },
              ],
              thu: [
                {
                  mode: 'on',
                  start: '06:30',
                  end: '13:30',
                  position: 0,
                },
                {
                  mode: 'on',
                  start: '14:00',
                  end: '16:30',
                  position: 1,
                },
                {
                  mode: 'on',
                  start: '17:00',
                  end: '20:40',
                  position: 2,
                },
                {
                  mode: 'on',
                  start: '21:40',
                  end: '24:00',
                  position: 3,
                },
              ],
              fri: [
                {
                  mode: 'on',
                  start: '06:30',
                  end: '13:30',
                  position: 0,
                },
                {
                  mode: 'on',
                  start: '14:00',
                  end: '16:30',
                  position: 1,
                },
                {
                  mode: 'on',
                  start: '17:00',
                  end: '20:40',
                  position: 2,
                },
                {
                  mode: 'on',
                  start: '21:40',
                  end: '24:00',
                  position: 3,
                },
              ],
              sat: [
                {
                  mode: 'on',
                  start: '06:30',
                  end: '13:30',
                  position: 0,
                },
                {
                  mode: 'on',
                  start: '14:00',
                  end: '16:30',
                  position: 1,
                },
                {
                  mode: 'on',
                  start: '17:00',
                  end: '20:40',
                  position: 2,
                },
                {
                  mode: 'on',
                  start: '21:40',
                  end: '24:00',
                  position: 3,
                },
              ],
              sun: [
                {
                  mode: 'on',
                  start: '06:30',
                  end: '13:30',
                  position: 0,
                },
                {
                  mode: 'on',
                  start: '14:00',
                  end: '16:30',
                  position: 1,
                },
                {
                  mode: 'on',
                  start: '17:00',
                  end: '20:40',
                  position: 2,
                },
                {
                  mode: 'on',
                  start: '21:40',
                  end: '24:00',
                  position: 3,
                },
              ],
            },
            type: 'Schedule',
          },
        },
        commands: {
          setSchedule: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.circulation.schedule/setSchedule',
            name: 'setSchedule',
            isExecutable: true,
            params: {
              newSchedule: {
                type: 'Schedule',
                required: true,
                constraints: {
                  modes: ['on'],
                  maxEntries: 4,
                  resolution: 10,
                  defaultMode: 'off',
                  overlapAllowed: false,
                },
              },
            },
          },
        },
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.circulation.schedule',
        timestamp: '2020-02-26T04:21:33.982Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.circulation.schedule',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.3.sensors.temperature',
        timestamp: '2020-02-26T04:20:58.403Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.3.sensors.temperature',
      },
      {
        properties: {
          value: {
            value: 61,
            type: 'number',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.device.time.offset',
        timestamp: '2020-02-26T04:21:31.765Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.device.time.offset',
      },
      {
        properties: {
          operationHours: {
            value: 7696,
            type: 'number',
          },
          insertions: {
            value: 0,
            type: 'number',
          },
          productionHours: {
            value: 5641,
            type: 'number',
          },
          productionStarts: {
            value: 177,
            type: 'number',
          },
          availabilityRate: {
            value: 0,
            type: 'number',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'fuelCell.statistics',
        timestamp: '2020-02-26T06:48:39.242Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/fuelCell.statistics',
      },
      {
        properties: {
          value: {
            value: 2644.7,
            type: 'number',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.power.sold.cumulative',
        timestamp: '2020-02-26T07:06:44.716Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.power.sold.cumulative',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.boiler.sensors.temperature',
        timestamp: '2020-02-26T04:20:58.403Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.boiler.sensors.temperature',
      },
      {
        properties: {
          value: {
            value: 38.6,
            unit: 'celsius',
            type: 'number',
          },
          status: {
            value: 'connected',
            type: 'string',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.sensors.temperature.supply',
        timestamp: '2020-02-26T07:11:34.316Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.sensors.temperature.supply',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.dhw.sensors.temperature',
        timestamp: '2020-02-26T04:20:58.403Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.dhw.sensors.temperature',
      },
      {
        properties: {
          active: {
            value: true,
            type: 'boolean',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.dhw',
        timestamp: '2020-02-26T04:21:33.973Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.dhw',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.device',
        timestamp: '2020-02-26T04:20:58.403Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.device',
      },
      {
        properties: {
          active: {
            value: true,
            type: 'boolean',
          },
          temperature: {
            value: 20,
            unit: 'celsius',
            type: 'number',
          },
        },
        commands: {
          setTemperature: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.operating.programs.normal/setTemperature',
            name: 'setTemperature',
            isExecutable: true,
            params: {
              targetTemperature: {
                type: 'number',
                required: true,
                constraints: {
                  min: 3,
                  max: 37,
                  stepping: 1,
                },
              },
            },
          },
        },
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.programs.normal',
        timestamp: '2020-02-26T06:19:40.178Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.programs.normal',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.operating.modes',
        timestamp: '2020-02-26T04:20:58.403Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.operating.modes',
      },
      {
        properties: {
          value: {
            value: 45.3,
            type: 'number',
          },
          status: {
            value: 'connected',
            type: 'string',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.dhw.sensors.temperature.dhwCylinder.top',
        timestamp: '2020-02-26T07:11:38.264Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.dhw.sensors.temperature.dhwCylinder.top',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.operating.modes.heating',
        timestamp: '2020-02-26T04:21:33.980Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.operating.modes.heating',
      },
      {
        properties: {
          shift: {
            type: 'number',
            value: 4,
          },
          slope: {
            type: 'number',
            value: 0.6,
          },
        },
        commands: {
          setCurve: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.1.heating.curve/setCurve',
            name: 'setCurve',
            isExecutable: true,
            params: {
              slope: {
                type: 'number',
                required: true,
                constraints: {
                  min: 0.2,
                  max: 3.5,
                  stepping: 0.1,
                },
              },
              shift: {
                type: 'number',
                required: true,
                constraints: {
                  min: -13,
                  max: 40,
                  stepping: 1,
                },
              },
            },
          },
        },
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.heating.curve',
        timestamp: '2020-02-26T04:21:33.981Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.heating.curve',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'fuelCell.operating',
        timestamp: '2020-02-26T04:20:58.402Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/fuelCell.operating',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating',
        timestamp: '2020-02-26T04:20:58.402Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.operating',
        timestamp: '2020-02-26T04:20:58.402Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.operating',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.modes',
        timestamp: '2020-02-26T04:20:58.403Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.modes',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.2.operating.programs',
        timestamp: '2020-02-26T04:20:58.402Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.2.operating.programs',
      },
      {
        properties: {
          value: {
            value: 22,
            type: 'number',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.power.production.demandCoverage.current',
        timestamp: '2020-02-26T04:21:34.271Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.power.production.demandCoverage.current',
      },
      {
        properties: {
          day: {
            value: [2.3, 8.2, 8.8, 7.7, 7.6, 7.4, 5.4, 6],
            type: 'array',
            unit: 'cubicMeter',
          },
          week: {
            value: [
              19.3,
              46.3,
              51.400000000000006,
              46.8,
              46.3,
              52.800000000000004,
              43.1,
              44.199999999999996,
            ],
            type: 'array',
            unit: 'cubicMeter',
          },
          month: {
            value: [174, 221.6, 239.6, 205, 55.6, 6.8, 5.6, 16.1, 12.5, 103.1, 92.3, 0, 0],
            type: 'array',
            unit: 'cubicMeter',
          },
          year: {
            value: [395.7, 736.8],
            type: 'array',
            unit: 'cubicMeter',
          },
          dayValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
          weekValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
          monthValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
          yearValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.gas.consumption.heating',
        timestamp: '2020-02-26T06:21:27.997Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.gas.consumption.heating',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.gas',
        timestamp: '2020-02-26T04:20:58.402Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.gas',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          temperature: {
            value: 18,
            type: 'number',
          },
        },
        commands: {
          setTemperature: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.operating.programs.reduced/setTemperature',
            name: 'setTemperature',
            isExecutable: true,
            params: {
              targetTemperature: {
                type: 'number',
                required: true,
                constraints: {
                  min: 3,
                  max: 37,
                  stepping: 1,
                },
              },
            },
          },
        },
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.programs.reduced',
        timestamp: '2020-02-26T06:19:40.178Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.programs.reduced',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.gas.consumption',
        timestamp: '2020-02-26T04:20:58.402Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.gas.consumption',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.2.sensors',
        timestamp: '2020-02-26T04:20:58.403Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.2.sensors',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.dhw.sensors',
        timestamp: '2020-02-26T04:20:58.403Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.dhw.sensors',
      },
      {
        properties: {
          value: {
            value: 'dhwAndHeating',
            type: 'string',
          },
        },
        commands: {
          setMode: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.operating.modes.active/setMode',
            name: 'setMode',
            isExecutable: true,
            params: {
              mode: {
                type: 'string',
                required: true,
                constraints: {
                  enum: ['standby', 'heating', 'dhw', 'dhwAndHeating'],
                },
              },
            },
          },
        },
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.modes.active',
        timestamp: '2020-02-26T04:21:34.273Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.modes.active',
      },
      {
        properties: {
          status: {
            value: 'notConnected',
            type: 'string',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.sensors.temperature.room',
        timestamp: '2020-02-26T04:21:33.981Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.sensors.temperature.room',
      },
      {
        properties: {
          value: {
            value: 46.3,
            type: 'number',
            unit: 'percent',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.burners.0.modulation',
        timestamp: '2020-02-26T07:13:13.204Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.burners.0.modulation',
      },
      {
        properties: {
          mode: {
            value: 'WeatherByOutsideSensorControlled',
            type: 'string',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.configuration.regulation',
        timestamp: '2020-02-26T04:20:58.485Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.configuration.regulation',
      },
      {
        properties: {
          active: {
            value: true,
            type: 'boolean',
          },
          name: {
            value: 'FUSSBODENHEIZUNG',
            type: 'string',
          },
          type: {
            value: 'heatingCircuit',
          },
        },
        commands: {
          setName: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.1/setName',
            name: 'setName',
            isExecutable: true,
            params: {
              name: {
                type: 'string',
                required: true,
                constraints: {
                  minLength: 1,
                  maxLength: 20,
                },
              },
            },
          },
        },
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1',
        timestamp: '2020-02-26T04:21:33.973Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.sensors.volumetricFlow',
        timestamp: '2020-02-26T04:20:58.403Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.sensors.volumetricFlow',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.3.operating.modes',
        timestamp: '2020-02-26T04:20:58.403Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.3.operating.modes',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.3.heating',
        timestamp: '2020-02-26T04:20:58.403Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.3.heating',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.3.operating',
        timestamp: '2020-02-26T04:20:58.402Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.3.operating',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.configuration',
        timestamp: '2020-02-26T04:20:58.403Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.configuration',
      },
      {
        properties: {
          value: {
            value: 1052.7,
            type: 'number',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.power.purchase.cumulative',
        timestamp: '2020-02-26T04:21:32.856Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.power.purchase.cumulative',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.heating',
        timestamp: '2020-02-26T04:20:58.402Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.heating',
      },
      {
        properties: {
          active: {
            value: true,
            type: 'boolean',
          },
          temperature: {
            value: 21,
            unit: 'celsius',
            type: 'number',
          },
        },
        commands: {
          setTemperature: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.1.operating.programs.normal/setTemperature',
            name: 'setTemperature',
            isExecutable: true,
            params: {
              targetTemperature: {
                type: 'number',
                required: true,
                constraints: {
                  min: 3,
                  max: 37,
                  stepping: 1,
                },
              },
            },
          },
        },
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.operating.programs.normal',
        timestamp: '2020-02-26T05:59:39.387Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.operating.programs.normal',
      },
      {
        properties: {
          shift: {
            type: 'number',
            value: 1,
          },
          slope: {
            type: 'number',
            value: 1.2,
          },
        },
        commands: {
          setCurve: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.heating.curve/setCurve',
            name: 'setCurve',
            isExecutable: true,
            params: {
              slope: {
                type: 'number',
                required: true,
                constraints: {
                  min: 0.2,
                  max: 3.5,
                  stepping: 0.1,
                },
              },
              shift: {
                type: 'number',
                required: true,
                constraints: {
                  min: -13,
                  max: 40,
                  stepping: 1,
                },
              },
            },
          },
        },
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.heating.curve',
        timestamp: '2020-02-26T04:21:33.981Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.heating.curve',
      },
      {
        isEnabled: true,
        isReady: true,
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.geofencing',
        deviceId: '0',
        timestamp: '2020-02-26T07:13:14.319Z',
        properties: {
          active: {
            type: 'boolean',
            value: false,
          },
          status: {
            type: 'string',
            value: 'home',
          },
        },
        commands: {},
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.geofencing',
      },
      {
        isEnabled: true,
        isReady: true,
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.geofencing',
        deviceId: '0',
        timestamp: '2020-02-26T07:13:14.319Z',
        properties: {
          active: {
            type: 'boolean',
            value: false,
          },
          status: {
            type: 'string',
            value: 'home',
          },
        },
        commands: {},
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.geofencing',
      },
      {
        isEnabled: true,
        isReady: true,
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.2.geofencing',
        deviceId: '0',
        timestamp: '2020-02-26T07:13:14.320Z',
        properties: {
          active: {
            type: 'boolean',
            value: false,
          },
          status: {
            type: 'string',
            value: 'home',
          },
        },
        commands: {},
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.2.geofencing',
      },
      {
        isEnabled: true,
        isReady: true,
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.3.geofencing',
        deviceId: '0',
        timestamp: '2020-02-26T07:13:14.321Z',
        properties: {
          active: {
            type: 'boolean',
            value: false,
          },
          status: {
            type: 'string',
            value: 'home',
          },
        },
        commands: {},
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.3.geofencing',
      },
    ];
  }
}
